
import React, { useState } from 'react';

import ForumIcon from '@material-ui/icons/Forum';
import CloseIcon from '@material-ui/icons/Close';
import OpenInFullIcon from '@material-ui/icons/Fullscreen';
import CloseFullscreenIcon from '@material-ui/icons/FullscreenExit';
import { Button } from "@material-ui/core";

import { getDynamicConfigValue } from "../../../dynamicConfig";

export default function Chat (showFraudEngines, showAMLEngines) {

    const [fullScreen, setFullScreen] = useState(false); 
    const [chatVisible, setChatVisible] = useState('hidden');

    const toggleChat = () => {
        if (chatVisible === 'hidden') {
            setChatVisible('visible');
        } else if (chatVisible === 'visible') {
            setChatVisible('hidden');
        }
    }

    const toggleFullScreen = () => setFullScreen(!fullScreen);

    return (
        <>
            <div style={{
                position: 'fixed',
                display: "flex",
                visibility: chatVisible,
                right: 20,
                bottom: 60,
                height: fullScreen ? 'calc(100vh - 140px)' : 'calc(50vh - 70px)',
                width: '92vw',
                zIndex: 10001,
                borderRadius: '5px',
                border: '2px solid #ddd',
                backgroundColor: '#fff'
            }}>
                <div style={{
                        display: 'flex',
                        flexFlow: 'column',
                        width: '100%'
                    }}>
                    <div style={{
                        flexGrow: 0,
                        display: 'flex',
                        //width: '100%',
                        height: '30px',
                        padding: '5px',
                        paddingTop: '10px',
                        background: '#eee'
                    }}>
                        <div style={{
                            flexGrow: 1, 
                            textAlign: 'left',
                            marginTop: '2px',
                        }}>Chat</div>
                        <div style={{
                            flexGrow: 0, 
                            display: 'flex',
                            flexFlow: 'row',
                            //marginTop: '-2px',
                            cursor: 'pointer',
                            width: '50px',
                        }}>
                            <div style={{
                                marginTop: '2px'
                            }} onClick={() => toggleFullScreen()}>
                                {fullScreen ?
                                    <CloseFullscreenIcon style={{fontSize: '1.3rem'}}/>
                                    :
                                    <OpenInFullIcon style={{fontSize: '1.3rem'}}/>
                                }
                            </div>
                            <div onClick={() => setChatVisible('hidden')}>
                                <CloseIcon/>
                            </div>
                        </div>
                    </div>
                    <div style={{
                        flexGrow: 1,
                        width: '100%'
                    }}>
                        <iframe
                            style={{
                                width: '100%',
                                height: '100%',
                                borderWidth: '0px'
                            }}
                            id="genAIChat"
                            title="GenAI Embed"
                            src={showFraudEngines.showFraudEngines == true ? getDynamicConfigValue('REACT_APP_FRAUD_GEN_AI_URL') : getDynamicConfigValue('REACT_APP_AML_GEN_AI_URL')}
                        />
                    </div>
                </div>
            </div>
            <div style={{
                position: 'fixed',
                display: "flex",
                justifyContent: 'center',
                alignItems: 'center',
                right: 20,
                bottom: 20,
                height: 40,
                width: 100,
                zIndex: 10000
            }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={toggleChat}
                    fullWidth
                    startIcon={<ForumIcon />}
                >
                    Chat
                </Button>
            </div>        
        </>
    )
}